import { render } from "./productFeatures.vue?vue&type=template&id=7107a852"
import script from "./productFeatures.vue?vue&type=script&lang=js"
export * from "./productFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__